import { render, staticRenderFns } from "./courseStatisticsIndex.vue?vue&type=template&id=06c00bd6&scoped=true&"
import script from "./courseStatisticsIndex.vue?vue&type=script&lang=js&"
export * from "./courseStatisticsIndex.vue?vue&type=script&lang=js&"
import style0 from "./courseStatisticsIndex.vue?vue&type=style&index=0&id=06c00bd6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c00bd6",
  null
  
)

export default component.exports